<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <div class="btn">
            <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
          </div>
        </el-form-item>
      </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
    >
      <el-table-column prop="companyName" label="公司名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="appId" label="商户标识" header-align="center" align="center"></el-table-column>
      <el-table-column prop="merNo" label="商户代码" header-align="center" align="center"></el-table-column>
      <el-table-column prop="userId" label="用户在系统中的唯一编号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="parentId" label="父ID(对应小贷在该表的主键)" header-align="center" align="center"></el-table-column>
      <el-table-column prop="keyStorePath" label="统统付商户的私钥证书名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="keyStorePassword" label="统统付提供给商户的私钥证书密码" header-align="center" align="center"></el-table-column>
      <el-table-column prop="publicKeyStorePath" label="统统付提供的公钥证书名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="virtualAccount" label="统统付虚拟账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="payType" label="支付方式" header-align="center" align="center">
        <template slot-scope="scope">
          {{ scope.row.payType== '0' ? '资方发起' : '小贷发起' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="开户时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="operate" label="操作" header-align="center" align="center" >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id,'update')">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
      
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './ttfopenaccount-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  components:{
    AddOrUpdate
  },
  data() {
    return {
      
      mixinViewModuleOptions: {
        getDataListURL: `/ttf/account/page`,
        getDataListIsPage: true,
        // multilist:true,

      },
    } 
  },
  created(){
    
  },
  methods:{
    
  }
}
</script>
<style scoped lang="scss">

  
</style>